import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ProAgeFormat",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "proAge/content",
      tickets: "proAge/tickets",
      isAuthenticated: "auth/isAuthenticated",
      isProfessional: "profile/isProfessional",
    }),
  },
  methods: {
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      addWebinarToBasket: "basket/ADD_WEBINAR_ITEM_TO_BASKET",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      changeSeminarInfo: "popups/SHOW_SEMINAR_INFO_POPUP",
      setSeminarInfoContent: "popups/SET_SEMINAR_INFO_CONTENT",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
    }),
    buyTicket(product) {
      if (!this.isAuthenticated) {
        this.showSeminarInfoPopup(
          "",
          "<p style='text-align: center; font-size: 18px; margin-top: 20px;'>Дане навчання доступне лише для авторизованих користувачів. Будь ласка, увійдіть у свій особистий кабінет</p>"
        );
        return;
      }
      if (!this.isProfessional) {
        this.showSeminarInfoPopup(
          "",
          "<p style='text-align: center; font-size: 18px; margin-top: 20px;'>Кейс форум - професійна подія для косметологів та клінік.<br>Зараз покупка квитка доступна лише для професійних учасників.</p><p style='text-align: center; font-size: 18px; margin-top: 16px;'>Якщо ви є практикуючим спеціалістом - ми з радістю активуємо для вас професійний статус. Зверніться до експерта SkinOn.</p>",
          "Чат з експертом",
          "https://t.me/Skinonexpert_bot"
        );
        return;
      }
      const productPrices = { ...product.productPrices.data[0] };
      productPrices.quantity = 1;
      productPrices.price = productPrices.basePrice;
      this.addWebinarToBasket({
        select_count: 1,
        product,
        product_price: productPrices,
      });
      this.changeBasketPopup(true);
      this.checkCoursesInBasket(product.id);
      this.$toasted.success("Квиток успішно додано в кошик");
    },
    showSeminarInfoPopup(title, description, buttonText, buttonLink) {
      this.changeSeminarInfo(true);
      this.setSeminarInfoContent({ title, description, buttonText, buttonLink });
    },
  },
};
